export function extractUrlPath(url: string) {
  const urlObject = new URL(url, 'http://example.com'); // Base URL is added for relative paths
  return urlObject.pathname;
}
